import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const TermsAndConditions = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Terms and Conditions</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <section id="grievance-policy">
                          <h6>1. Introduction</h6>
                          <p>
                            Welcome to the {APP_INFO.companyName}. These Terms
                            and Conditions ("Terms") govern your access to and
                            use of our application and services ("Services"). By
                            registering for, accessing, or using the Services,
                            you agree to comply with these Terms. If you do not
                            agree with any part of these Terms, you must
                            discontinue use of our Services immediately.
                          </p>

                          <h6>2. Definitions</h6>
                          <p>For the purposes of these Terms:</p>
                          <ul>
                            <li>
                              <strong>"Company," "we," "us," and "our"</strong>{" "}
                              refer to {APP_INFO.companyName}.
                            </li>
                            <li>
                              <strong>"User," "you," and "your"</strong> refer
                              to the individual accessing or using our Services.
                            </li>
                            <li>
                              <strong>"Account"</strong> means the account you
                              create to access our Services.
                            </li>
                            <li>
                              <strong>"Recharge Services"</strong> refer to
                              mobile, DTH, and other recharge services provided
                              through our platform.
                            </li>
                          </ul>

                          <h6>3. Account Registration</h6>
                          <p>
                            To use our Services, you must register for an
                            account by providing accurate and complete
                            information. You agree to keep your account
                            information updated at all times. You are solely
                            responsible for maintaining the confidentiality of
                            your account credentials and for all activities that
                            occur under your account.
                          </p>

                          <h6>4. Use of Services</h6>
                          <p>
                            By using our Services, you agree to the following:
                          </p>
                          <ul>
                            <li>
                              You will not use the Services for any unlawful,
                              fraudulent, or malicious activities.
                            </li>
                            <li>
                              You will provide accurate information when using
                              our Services and ensure that all transactions
                              comply with applicable laws and regulations.
                            </li>
                            <li>
                              You will not interfere with, disrupt, or attempt
                              to gain unauthorized access to the Services, user
                              accounts, or any networks connected to the
                              Services.
                            </li>
                            <li>
                              You will comply with all additional policies and
                              guidelines provided by the Company.
                            </li>
                          </ul>

                          <h6>5. Payment and Charges</h6>
                          <p>
                            All payments for recharge transactions must be made
                            through the payment methods available in the
                            platform. You agree to pay all applicable fees,
                            charges, and taxes associated with your use of the
                            Services. The Company reserves the right to change
                            the pricing and payment policies at any time, with
                            prior notice to users.
                          </p>

                          <h6>6. Refund Policy</h6>
                          <p>
                            Refunds for transactions made through our Services
                            are governed by our Refund Policy. Refunds will only
                            be issued under specific conditions, such as failed
                            or unsuccessful transactions. Please review our
                            Refund Policy for detailed information on
                            eligibility, procedures, and timelines.
                          </p>

                          <h6>7. Commission and Earnings</h6>
                          <p>
                            If you are a partner or affiliate earning
                            commissions through our Services, the following
                            terms apply:
                          </p>
                          <ul>
                            <li>
                              Commissions will be credited to your account as
                              per the terms specified.
                            </li>
                            <li>
                              Commissions are subject to deductions for any
                              refunds, chargebacks, or penalties incurred by the
                              Company.
                            </li>
                            <li>
                              The Company reserves the right to modify
                              commission rates and payout schedules at any time,
                              with prior notice to partners.
                            </li>
                          </ul>

                          <h6>8. Intellectual Property Rights</h6>
                          <p>
                            All content, logos, trademarks, and other
                            intellectual property used in connection with the
                            Services are the property of {APP_INFO.companyName}{" "}
                            or its licensors. You may not use, reproduce,
                            modify, or distribute any of our intellectual
                            property without prior written permission from the
                            Company.
                          </p>

                          <h6>9. Limitation of Liability</h6>
                          <p>
                            To the maximum extent permitted by law,{" "}
                            {APP_INFO.companyName} and its affiliates, officers,
                            directors, employees, and agents shall not be liable
                            for any direct, indirect, incidental, special, or
                            consequential damages arising out of or in
                            connection with your use of the Services, including
                            but not limited to damages for loss of profits,
                            data, goodwill, or other intangible losses.
                          </p>

                          <h6>10. Indemnification</h6>
                          <p>
                            You agree to indemnify and hold harmless
                            {APP_INFO.companyName} and its affiliates, officers,
                            directors, employees, and agents from any claims,
                            liabilities, damages, losses, and expenses
                            (including legal fees) arising out of your use of
                            the Services, your violation of these Terms, or your
                            infringement of any third-party rights.
                          </p>

                          <h6>11. Termination</h6>
                          <p>
                            The Company reserves the right to terminate or
                            suspend your account and access to the Services,
                            with or without notice, for any reason, including
                            but not limited to violations of these Terms,
                            fraudulent activities, or unlawful conduct. Upon
                            termination, you must immediately cease all use of
                            the Services and any associated content.
                          </p>

                          <h6>12. Governing Law and Jurisdiction</h6>
                          <p>
                            These Terms and Conditions are governed by and
                            construed in accordance with the laws of Kolkata,
                            India. Any disputes arising out of or in connection
                            with these Terms will be subject to the exclusive
                            jurisdiction of the courts of Kolkata, India.
                          </p>

                          <h6>13. Modifications to Terms</h6>
                          <p>
                            {APP_INFO.companyName} reserves the right to modify
                            these Terms and Conditions at any time. Users will
                            be notified of significant changes through platform
                            notifications or email. Your continued use of the
                            Services after any such modifications signifies your
                            acceptance of the revised Terms.
                          </p>

                          <h6>14. Privacy Policy</h6>
                          <p>
                            Your use of the Services is also governed by our
                            Privacy Policy, which outlines how we collect, use,
                            and protect your personal information. Please review
                            the Privacy Policy carefully before using our
                            Services.
                          </p>

                          <h6>15. Contact Information</h6>
                          <p>
                            If you have any questions or concerns regarding
                            these Terms and Conditions, please contact our
                            support team at <strong>{APP_INFO.email}</strong>.
                            We are committed to addressing your inquiries
                            promptly and efficiently.
                          </p>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
